<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="chp" id="_idParaDest-2"><a id="_idTextAnchor001"></a>Also by Michael Slade</h1>
<p class="center"><i>Ghoul</i></p>
<p class="center"><i>Cutthroat</i></p>
<p class="center"><i>Ripper</i></p>
<p class="center"><i>Zombie</i></p>
<p class="center"><i>Primal Scream</i></p>
<p class="center"><i>Burnt Bones</i></p>
<p class="center"><i>Hangman</i></p>
<p class="center"><i>Death’s Door</i></p>
<p class="center"><i>Bed of Nails</i></p>
<p class="center"><i>Swastika</i></p>
<p class="center"><i>Kamikaze</i></p>
<p class="center"><i>Crucified</i></p>
<p class="center"><i>Red Snow</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Headhunter-1.vue?40d63760